<template>
  <div class="recipient-list-select" :class="{ isSendGift: !isGroupOrder }">
    <v-select
      :class="isGroupOrder ? 'glass' : 'custom gift-select'"
      :placeholder="placeholder"
      label="file_name"
      :options="recipientList"
      :value="
        isGroupOrder
          ? []
          : trimText(
              !isOrderRecipient
                ? selectedOption[0].file_name
                : selectedOrderRecipient.file_name,
              30
            )
      "
      @input="handleChange"
      :clearable="false"
      :searchable="false"
      :closeOnSelect="isGroupOrder ? false : true"
      :multiple="isGroupOrder ? true : false"
    >
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes"
          ><svg
            width="9"
            height="5"
            viewBox="0 0 9 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.5 5C4.38766 5 4.27531 4.95646 4.18974 4.86983L0.128691 0.758491C-0.0428968 0.584779 -0.0428968 0.303996 0.128691 0.130284C0.300278 -0.043428 0.577626 -0.043428 0.749214 0.130284L4.5 3.92752L8.25079 0.130284C8.42237 -0.043428 8.69972 -0.043428 8.87131 0.130284C9.0429 0.303996 9.0429 0.584779 8.87131 0.758491L4.81026 4.86983C4.72469 4.95646 4.61234 5 4.5 5Z"
              fill="#25282A"
            />
          </svg>
        </span>
      </template>

      <template v-if="isGroupOrder" #option="{ id, file_name }">
        <div>
          <label class="checkbox-container">
            <p>{{ file_name }}</p>
            <input
              type="checkbox"
              v-if="!isEcommerceRecipientList"
              @change="handleSelection(id, file_name)"
              :checked="selectedOption.find(list => list.id === id)"
            />
            <input
              v-else
              type="checkbox"
              @change="handleSelection(id, file_name)"
              :checked="
                selectedEcommerceRecipientList.find(list => list.id === id)
              "
            />
            <span v-if="isEcommerceRecipientList">
              <span
                v-if="
                  !selectedEcommerceRecipientList.find(list => list.id === id)
                "
                class="checkmark"
              ></span>
              <span v-else class="checkmark-checked"></span>
            </span>
            <span v-else>
              <span
                v-if="!selectedOption.find(list => list.id === id)"
                class="checkmark"
              ></span>
              <span v-else class="checkmark-checked"></span>
            </span>
          </label>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { trimText } from '@/helpers'
export default {
  name: 'RecipientListDropdown',
  props: {
    recipientList: {
      type: Array,
      default: () => []
    },

    placeholder: {
      type: String,
      default: 'Select a recipient list*'
    },

    isOrderRecipient: {
      type: Boolean,
      default: false
    },

    isGroupOrder: {
      type: Boolean,
      default: false
    },
    isEcommerceRecipientList: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    allowListUploaded: {
      handler: function(val) {
        if (val) {
          this.clearSelectedList()
        }
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    ...mapState({
      selectedOption: state => state.recipient.selectedRecipientList,
      selectedOrderRecipient: state => state.recipient.orderRecipientList,
      allowListEcommerce: state => state.groupOrder.allowListEcommerce,
      selectedEcommerceRecipientList: state =>
        state.recipient.selectedEcommerceRecipientList,
      allowListUploaded: state => state.groupOrder.allowListUploaded
    })
  },

  data: () => ({
    selectedLists: [],
    trimText: trimText
  }),

  methods: {
    handleChange(value) {
      this.$store.dispatch('recipient/setSelectedRecipientList', value)
      this.$store.dispatch('order/resetInventoryCheck')
      this.$store.dispatch('inventory/resetRequestEstimateCount')
    },

    handleSelection(id, file_name) {
      if (this.selectedLists.find(list => list.id === id)) {
        this.selectedLists = this.selectedLists.filter(list => list.id !== id)
      } else {
        this.selectedLists.push({ id, file_name })
      }
      this.$emit('handleSelection', this.selectedLists)
    },

    clearSelectedList() {
      this.selectedLists = []
      this.$emit('handleSelection', [])
      this.$store.commit('groupOrder/ALLOW_LIST_UPLOADED', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.recipient-list-select {
  flex-basis: 45%;
  display: flex;
  flex-direction: column;
  padding: 0;

  &.isSendGift {
    width: 35%;
    padding: 20px 0px;
  }

  .glass {
    border-bottom: 1px solid;
    height: 48px;
  }

  .checkbox-container {
    p {
      color: #222222;
      font-size: 0.75rem;
      margin-left: 32px;
      margin-top: 3px;
    }
  }
}

@media (max-width: 568px) {
  .recipient-list-select {
    &.isSendGift {
      width: 100%;
    }
  }
}
</style>
